var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"mb-4 pa-4"},[_c('p',{staticClass:"text-h6 secondary--text"},[_vm._v("Histórico de pagos")]),_c('ListadoPagosComponent',{attrs:{"hideActions":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }